import includes from 'lodash/includes';

const filterOutDeletedStateInteractions = stateInteractions => stateInteractions.filter(item => !item.deleted);

export function getInteractionOnSubmissionForType(
  allStateInteractions,
  contentId,
  userId,
  submissionId,
  interactionType
) {
  try {
    const stateInteractions = [];
    allStateInteractions.forEach((stateInteraction) => {
      const interactionKey = `${contentId}_${interactionType}_${submissionId}`;
      if (
        stateInteraction.contentId === contentId
        && stateInteraction.userId === userId
        && includes(stateInteraction.contentId_interactionType_interactingOnId_actorId, interactionKey)
      ) {
        stateInteractions.push(stateInteraction);
      }
    });
    return filterOutDeletedStateInteractions(stateInteractions);
  } catch (error) {
    console.log('Error in getInteractionForType ' + error);
    throw error;
  }
}

export function getPeerReviewStateInteractions(
  stateInteractions,
  questionId,
  userId,
  submissionId
) {
  return getInteractionOnSubmissionForType(
    stateInteractions,
    questionId,
    userId,
    submissionId,
    'peerReview'
  );
}

export function getFeedbackStateInteractions(stateInteractions, questionId, userId, submissionId) {
  return getInteractionOnSubmissionForType(
    stateInteractions,
    questionId,
    userId,
    submissionId,
    'feedback'
  );
}

export function getGradeStateInteractions(stateInteractions, questionId, userId, submissionId) {
  return getInteractionOnSubmissionForType(
    stateInteractions,
    questionId,
    userId,
    submissionId,
    'grade'
  );
}

export function getEvaluationStateInteractions(
  stateInteractions,
  questionId,
  userId,
  submissionId
) {
  const interactions = getInteractionOnSubmissionForType(
    stateInteractions,
    questionId,
    userId,
    submissionId,
    'evaluation'
  );
  return interactions.filter(evalution => evalution.reviews && evalution.reviews.length > 0);
}
